import { render } from "./CourseItemSmall.vue?vue&type=template&id=e6c32d04"
import script from "./CourseItemSmall.vue?vue&type=script&lang=js"
export * from "./CourseItemSmall.vue?vue&type=script&lang=js"

import "./CourseItemSmall.vue?vue&type=style&index=0&id=e6c32d04&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__